import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions } from "store";
import { BalanceList } from 'components/blocks/balance';


class BalanceListScreen extends Component {
    render() {
        const { history } = this.props;

        return (
            <div className="page">
                <div className="page-header">
                    <div className="page-header-title">Балансы пользователей</div>
                </div>

                <div className="page-content page-content-full">
                    <div className="page-block page-block-full">
                        <BalanceList history={history}/>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        balance: state.balance,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.balance), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(BalanceListScreen);
